import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthenticateRouter = ({ children }) => {
  const location = useLocation();
  const currentPathName = location?.pathname;
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const { menu_list } = useSelector((x) => x?.auth);
  const isMaintenanceModeActive = useSelector(
    (state) => state?.master?.applicationSettingsData?.IsApplicationMaintenance
  );

  const checkPathExists = (pathname) => {
    return menu_list?.some(
      (menuItem) =>
        menuItem.URLPath === pathname ||
        menuItem?.SubMenus?.some((subMenu) => subMenu.Subpath === pathname)
    );
  };
  return isLoggedIn &&
    (currentPathName !== "/Admin/support" &&
      currentPathName !== "/Admin/ChangePassword" &&
      currentPathName !== "/Admin/Maintenance"
      ? checkPathExists(currentPathName)
      : true) ? (
    children
  ) : isLoggedIn && isMaintenanceModeActive === 1 ? (
    <Navigate to="/Admin/Maintenance" replace />
  ) : (
    <Navigate to="/facilityuser" replace />
  );
};

export default AuthenticateRouter;
